import api from './axiosConfig';

export const getDailyReceivedCapsules = async (date) => 
{
    try 
    {
        const response = await api.get(`/capsules/getDailyReceivedCapsules/${date}`);

        console.log(`Daily received capsules for date ${date} are`, response.data);
        return response.data;
    }
    catch(error) 
    {
        console.error('Error fetching daily received capsules:', error);
        throw error.response?.data || error.message;
    }
}

// Call getAllCapsules from backend, if date is provided, filter by date
export const getAllCapsules = async (params) => 
{
    try 
    {
        const response = await api.get('/capsules/getAllCapsules', { params });
        
        return response;
    } 
    catch (error) 
    {
        console.error('Error fetching capsules:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch capsules';
    }
};

export const getCapsuleStats = async (date, source = 'all') =>
{
    try 
    {
        const params = {};
        if (typeof date === 'string' && date.trim()) {
            params.date = date.trim();
        }
        if (typeof source === 'string' && source.trim() && source.trim().toLowerCase() !== 'all') {
            params.source = source.trim().toLowerCase();
        }

        const response = await api.get(`/capsules/statistics`, {
            params
        });
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error fetching capsule stats:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch capsule stats';
    }
}

// Call addCapsule from backend
export const addCapsule = async(capsuleData) =>
{
    try
    {
        const response = await api.post('/capsules/addCapsule', capsuleData);
        return response.data;
    } 
    catch (error) 
    {
        console.error('FrontendError adding capsule:', error);
        throw error.response?.data?.message || error.message || 'Failed to add capsule';
    }
};

// Call deleteCapsule from backend, not using at this time
export const deleteCapsule = async (SN) => 
{
    try 
    {
        const response = await api.delete('/capsules/deleteCapsule', 
        {
            params: { SN },
        });
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error deleting capsule:', error);
        throw error.response?.data?.message || error.message || 'Failed to delete capsule';
    }
};

//Call backend getVideo URL to get duo vide, pano video, and video meta urls
export const getVideoURL = async (SN) => 
{
    try 
    {
        const response = await api.get('/capsules/getVideoURL', 
        {
            params: { SN },
        });
        console.log("Video URL is", response.data);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error fetching video URL:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch video URL';
    }
};

// Call backend editNotes to edit notes for a capsule
export const editNotes = async (userData) => 
{
    try 
    {
        const response = await api.post('/capsules/editNotes', userData);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error editing notes:', error);
        throw error.response?.data?.message || error.message || 'Failed to edit notes';
    }
};

// Function to change the video status of a capsule
export const changeVideoStatus = async (userData) => 
{
    try 
    {
        const response = await api.post('/capsules/changeVideoStatus', 
        {
            userData,
        });
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error changing video status:', error);
        throw error.response?.data?.message || error.message || 'Failed to change video status';
    }
};

// Call backend approveVideo_AWS to approve video using AWS SDK
export const approveVideo_AWS = async (SN) =>
{
    try
    {
        const response = await api.post('/capsules/approveVideo_AWS', SN);
        return response.data;
    }
    catch(error)
    {
        console.error('Error approving video using AWS SDK', error);
        throw error.response?.data?.message || error.message || 'Failed to approve video';
    }
}

// Call backend rejectVideo_AWS to reject video using AWS SDK
export const rejectVideo_AWS = async (SN) =>
{
    try
    {
        const response = await api.post('/capsules/rejectVideo_AWS', SN);
        return response.data;
    }
    catch(error)
    {
        console.error('Error rejecting video using AWS SDK', error);
        throw error.response?.data?.message || error.message || 'Failed to reject video';
    }
}

// Call backend retranscodeVideo to retranscode video using AWS Lambda SDK
export const retranscodeVideo = async(payload) =>
{
    try
    {
        const response = await api.post('/capsules/retranscodeVideo', payload);
        return response.data;
    }
    catch(error)
    {
        console.error('Error retranscoding using AWS Lambda SDK', error);
        throw error;
    }
}


// Previous version approveVideo, not using at this time
export const approveVideo = async (SN) => 
{
    try 
    {
        const response = await api.post('/capsules/approveVideo', SN);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error approving video:', error);
        throw error.response?.data?.message || error.message || 'Failed to approve video';
    }
};

// Previous version rejectVideo, not using at this time
export const rejectVideo = async (SN) => 
{
    try 
    {
        const response = await api.post('/capsules/rejectVideo', SN);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error rejecting video:', error);
        throw error.response?.data?.message || error.message || 'Failed to reject video';
    }
};

// Function to get the issue log for a capsule
export const getIssueLog = async (SN) => 
{
    try 
    {
        const response = await api.get('/capsules/getIssueLog', 
        {
            params: {SN},
        });
        console.log("Frontend issue log is", response.data);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error fetching issue log:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch issue log';
    }
};

//Previous version getCSV, not using at this time
export const getCSV = async (SN) => 
{
    try 
    {
        const response = await api.get('/capsules/getCSV', 
        {
            params: { SN },
        });
        return response.data;  // Return the CSV data from the response
    } 
    catch (error) 
    {
        console.error('Error fetching CSV:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch CSV';
    }
};

// Call backend getBin to get the binary data for a capsule
export const getBin = async (SN) => 
{
    try 
    {
        const response = await api.get('/capsules/getBin', 
        {  // Make a GET request to the /getBin endpoint
            params: { SN },  // Pass the SN as a query parameter
        });
        return response.data;  // Return the binary data from the response
    } 
    catch (error) 
    {
        console.error('Error fetching bin file:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch binary';
    }
};

// Call backend getBinDirect to get the binary data for a capsule using AWS SDK
export const getBinDirect = async (SN) => 
{
    try 
    {
        const response = await api.get('/capsules/getBinDirect', 
        {
            params: { SN },
        });
        return response.data;  // Return the binary data from the response
    } 
    catch (error) 
    {
        console.error('Error fetching bin files directly:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch binary files directly';
    }
};

/**
 * Function to edit CSV files associated with a capsule.
 * @param {Object} csvData - Object containing the SN and new CSV file URLs.
 * @param {string} csvData.SN - The serial number of the capsule.
 * @param {string} csvData.main_csv - The new main CSV file URL (optional).
 * @param {string} csvData.supp_1_csv - The new supplement 1 CSV file URL (optional).
 * @param {string} csvData.supp_2_csv - The new supplement 2 CSV file URL (optional).
 * @returns {Promise<Object>} The response data from the backend.
 */
export const editCSV = async (csvData) => 
{
    try 
    {
        const response = await api.post('/capsules/editCSV', csvData, 
        {
        });
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error editing CSV:', error);
        throw error.response?.data?.message || error.message || 'Failed to edit CSV';
    }
};

/**
 * Function to edit binary files associated with a capsule.
 * @param {Object} binData - Object containing the SN and new binary file URLs.
 * @param {string} binData.SN - The serial number of the capsule.
 * @param {string} binData.main_bin - The new main binary file URL (optional).
 * @param {string} binData.supp_1_bin - The new supplement 1 binary file URL (optional).
 * @param {string} binData.supp_2_bin - The new supplement 2 binary file URL (optional).
 * @returns {Promise<Object>} The response data from the backend.
 */
export const editBin = async (binData) => 
{
    try 
    {
        const response = await api.post('/capsules/editBin', binData,);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error editing binary:', error);
        throw error.response?.data?.message || error.message || 'Failed to edit binary';
    }
};

// Previous version getXAM, not using at this time
export const getXAM = async (SN) => 
{
    try 
    {
        const response = await api.get("/capsules/getXAM", 
        {
            params: { SN },
        });
        console.log("XAM link is", response.data);
        return response.data;
    } 
    catch (error) 
    {
        throw error.response.data.message || 'Failed to retrieve XAM log';
    }
};

// Call backend getXAM_AWS to get the XAM log file path for a capsule using AWS SDK
export const getXAM_AWS = async (SN) => 
{
    try 
    {
        const response = await api.get("/capsules/getXAM_AWS", 
        {
            params: { SN },
        });
        console.log("XAM link is", response.data);
        return response.data;
    } 
    catch (error) 
    {
        throw error.response.data.message || 'Failed to retrieve XAM log';
    }
};

// Call backend updateCapsuleStatus to update the status of a capsule (bin issue, video issue, etc.)
export const updateCapsuleStatus = async(SN, newStatus) =>
{
    try 
    {
        // Use the api instance which includes the interceptor
        const response = await api.post(`/capsules/updateCapsuleStatus`, 
        {
            SN,
            newStatus,
        });
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error updating capsule status:', error);
        throw error.response?.data?.message || error.message || 'Failed to update capsule status';
    }
}

// Call backend redownloadVideo to redownload the video for a capsule using a bin file dropbox to S3
export const redownloadVideo = async (SN, formData) => 
{
    try 
    {
        // Creating a custom config to handle FormData
        const config = 
        {
            headers: 
            {
                'Content-Type': 'multipart/form-data',
            },
        };
        
        // Make sure SN is included in the formData
        if (!formData.has('SN')) 
        {
            formData.append('SN', SN);
        }
        
        const response = await api.post('/capsules/redownloadVideo', formData, config);
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error redownloading video:', error);
        throw error.response?.data?.message || error.message || 'Failed to redownload video';
    }
}

// Call backend updateRMAStatus to update the investigation status of a capsule with investigation notes
export const updateRMAStatus = async (SN, RMA_status, RMA_note) => 
{
    try 
    {
        const response = await api.post('/capsules/updateRMAStatus', 
        {
            SN,
            RMA_status,
            RMA_note
        }); 
        return response.data;
    } 
    catch (error) 
    {
        console.error('Error updating investigation status:', error);
        throw error.response?.data?.message || error.message || 'Failed to update investigation status';
    }
}

// Call backend getCSVDirect to get the CSV files for a capsule using AWS SDK
export const getCSVDirect = async (SN) => 
{
    try 
    {
        console.log("In the getCSVDirect function");
        const response = await api.get('/capsules/getCSVDirect', 
        {
            params: { SN },
        });
        console.log("CSV files are", response.data);
        return response.data;  // Return the CSV data from the response
    } 
    catch (error) 
    {
        console.error('Error fetching CSV files directly:', error);
        throw error.response?.data?.message || error.message || 'Failed to fetch CSV files directly';
    }
};

export const transitionCapsule = async (SN, payload) => {
    try {
        const response = await api.post(`/capsules/${SN}/transition`, payload);
        return response.data;
    } catch (error) {
        console.error('Error transitioning capsule state:', error);
        throw error.response?.data?.message || error.message || 'Failed to transition capsule state';
    }
};
